import { render, staticRenderFns } from "./CalendarUserBadge.vue?vue&type=template&id=4b641bf0&scoped=true"
import script from "./CalendarUserBadge.vue?vue&type=script&lang=js"
export * from "./CalendarUserBadge.vue?vue&type=script&lang=js"
import style0 from "./CalendarUserBadge.vue?vue&type=style&index=0&id=4b641bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b641bf0",
  null
  
)

export default component.exports